import styled, { css } from 'styled-components';

import { breakpoints, theme } from '@notino/react-styleguide';

export const Wrapper = styled.div`
  width: 100%;

  @media (min-width: ${breakpoints.md}) {
    width: 66%;
  }
`;

export const SectionTitle = styled.p<{ newDesign: boolean }>`
  padding-top: 1.3rem;

  ${({ newDesign }) =>
    newDesign
      ? css`
          ${theme.typography.titleMedium}
          margin: 0 0 0.75rem;
        `
      : css`
          font-size: 0.9rem;
          line-height: 1.5;
          font-weight: 700;
          margin: 0;

          @media (min-width: ${breakpoints.md}) {
            font-size: 1.1rem;
          }
        `}
`;

export const Text = styled.div<{ newDesign: boolean }>`
  line-height: 1.5rem;
  margin: 0 0 0.3rem;
  font-size: 0.9rem;

  strong {
    font-size: 0.8rem;
  }

  ${({ newDesign }) =>
    newDesign &&
    css`
      color: ${theme.palette.neutralDarker};

      strong {
        font-size: inherit;
      }
    `}
`;
